export default {"src":"/_next/static/media/close.7687aff7.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};